import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  totalActiveUserCount: number;
  totalInactiveUserCount: number;
  totalSignupCount: number;
  totalHighUsageAccountCount: number;
  loading: boolean;
};
function UserMeta({
  totalActiveUserCount,
  loading,

  totalHighUsageAccountCount,
  totalInactiveUserCount,
  totalSignupCount,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>New signups</h5>
        <p className={s.statNumber}>{totalSignupCount.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Active users</h5>
        <p className={s.statNumber}>{totalActiveUserCount.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Inactive users</h5>
        <p className={s.statNumber}>
          {totalInactiveUserCount.toLocaleString()}
        </p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>High usage accounts</h5>
        <p className={s.statNumber}>
          {totalHighUsageAccountCount.toLocaleString()}
        </p>
      </div>
    </div>
  );
}

export default UserMeta;
